import { SERVICES } from "../lib/constants";
import { ArrowUpRight } from "@phosphor-icons/react";
import { motion } from "framer-motion";

const INTERIOR =
  "https://static.prod-images.emergentagent.com/jobs/f356e486-2013-43a6-a960-a50c27505bc4/images/75f2120a4fe107604a218f57504f707b8789ee66196a1991f894320e1f039524.png";
const EXTERIOR =
  "https://static.prod-images.emergentagent.com/jobs/f356e486-2013-43a6-a960-a50c27505bc4/images/f86b282158739f429080d6b94bc760d843f39b4dbaeff7583cfe4b463469c7e4.png";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-20 md:py-32 px-5 md:px-10 lg:px-16 bg-[#1A1A1A] text-[#F2F2EF] grain"
    >
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
        <div>
          <p className="section-num mb-3" style={{ color: "#D85C3A" }}>02 — Services</p>
          <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] tracking-tighter">
            Six things<br />we do <span className="text-[#D85C3A]">very</span> well.
          </h2>
        </div>
        <p className="max-w-md text-[#bbb]">
          Each service runs on the same playbook: full prep, premium paints (Dulux / Wattyl /
          Taubmans), tidy crews, and a fixed quote you can hold us to.
        </p>
      </div>

      <div className="grid grid-cols-12 gap-3 md:gap-4">
        {/* Big interior image */}
        <div className="col-span-12 md:col-span-6 row-span-2 border-2 border-[#F2F2EF] overflow-hidden aspect-[4/5] md:aspect-auto">
          <img src={INTERIOR} alt="Interior painting — premium walls and ceilings by The Melbourne Painters" className="w-full h-full object-cover" loading="lazy" decoding="async" width="800" height="1000" />
        </div>

        {SERVICES.map((s, i) => (
          <motion.a
            key={s.key}
            href="#book"
            data-testid={`service-card-${s.key}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: i * 0.05 }}
            className="col-span-12 sm:col-span-6 md:col-span-3 border-2 border-[#F2F2EF] p-6 group hover:bg-[#D85C3A] transition-colors duration-300 flex flex-col justify-between min-h-[200px]"
          >
            <div className="flex items-start justify-between">
              <span className="font-display text-3xl">0{i + 1}</span>
              <ArrowUpRight size={28} weight="bold" className="opacity-50 group-hover:opacity-100 group-hover:rotate-45 transition-all" />
            </div>
            <div>
              <h3 className="font-display text-2xl uppercase tracking-tight mb-2">{s.title}</h3>
              <p className="text-sm text-[#bbb] group-hover:text-white">{s.blurb}</p>
            </div>
          </motion.a>
        ))}

        {/* Big exterior image */}
        <div className="col-span-12 md:col-span-6 border-2 border-[#F2F2EF] overflow-hidden aspect-[16/9]">
          <img src={EXTERIOR} alt="Exterior weatherboard painting — Melbourne 2-storey heritage home" className="w-full h-full object-cover" loading="lazy" decoding="async" width="1200" height="675" />
        </div>
      </div>
    </section>
  );
}
